import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {ModalController} from '@ionic/angular';
import {ConfigurationService} from '../../services/configuration.service';
import {EquipmentSelectScaffoldingPage} from '../../modals/scaffolding/equipment-select-scaffolding/equipment-select-scaffolding.page';

@Component({
    selector: 'items-scaffolding',
    templateUrl: './items-scaffolding.component.html',
    styleUrls: ['./items-scaffolding.component.scss'],
})
export class ItemsScaffoldingComponent implements OnInit {

    @Input() document: DocumentModel;
    private detailLine: DetaillineDTOModel;
    private mobileConfig: any;
    private displayConsumables: boolean;

    constructor(private modalController: ModalController,
                private config: ConfigurationService) {
    }

    async ngOnInit() {
        this.mobileConfig = await this.config.getMobileConfiguration();
        this.displayConsumables = this.mobileConfig.mobilehireScaffoldingInUse !== 1;
    }

    async equipProdModal() {
        const modal = await this.modalController.create({
            component: EquipmentSelectScaffoldingPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'detailLine': this.detailLine,
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.document.detailLines = dataReturned.data;
            }
        });

        return await modal.present();
    }

}
